import React, {useState} from 'react'

export const AccordianSection=({heading,component})=>{

    const [arrowClass,setArrowClass]=useState("glyphicon glyphicon-minus")
    const [displayClass,setDisplayClass]=useState("show")

    const toggle=(arrowClass)=>{
        arrowClass==="glyphicon glyphicon-plus"?setArrowClass("glyphicon glyphicon-minus"):setArrowClass("glyphicon glyphicon-plus")
        displayClass==="hide"?setDisplayClass("show"):setDisplayClass("hide")

    }
    return <div className='accordian-section'>
        <div className='accordian-heading' onClick={(ev)=>toggle(arrowClass)}>{heading}<i className={`${arrowClass} pos-right`}/></div>
        <div className={displayClass}>
        {component}
        </div>
    </div>
}